import React from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { SearchResultsInfinite } from '@uncinc/react-searchkit';

import WysiwygField from '../../../components/WysiwygField';
import PartnerSearchWrapper from '../../../components/PartnerSearch/Wrapper';
import PartnerItem from '../../../components/PartnerSearch/PartnerItem';

import './style.scss';

interface HighlightedPartnersProps {
  entity: ImmutableEntity<any>;
}

const HighlightedPartners: React.FC<HighlightedPartnersProps> = ({ entity }) => {
  const paragraph = entity.toJS();
  const title = paragraph.field_title[0].value;
  const body = paragraph.field_body[0].processed;

  return (
    <div className="Paragraph ParagraphHighlightedPartners">
      <Container className="ParagraphHighlightedPartners__inner">
        <h3 className="ParagraphHighlightedPartners__title">{title}</h3>
        {body && (
          <WysiwygField
            property="schema:text"
            className="TextBlock subheading2"
            html={body}
          />
        )}
        <PartnerSearchWrapper hitsPerPage={100}>
          <SearchResultsInfinite
            className="HighlightedPartners__results"
            renderItem={(hit: any) => <PartnerItem hit={hit} />}
          />
        </PartnerSearchWrapper>
      </Container>
    </div>
  );
};

export default HighlightedPartners;
